import React from "react";
import "./css/RadioGroup.css";

export type RadioOption<T> = {
    value: T;
    label: React.ReactNode;
};

export type RadioGroupColors = {
    border?: string;
    foreground?: string;
    background?: string;
    hover?: string;
};

export type RadioGroupProps<T> = {
    name: string;
    value: T;
    onChange: (value: T) => void;
    options: RadioOption<T>[];
    className?: string;
    colors?: RadioGroupColors;
};

export function RadioGroup<T>({
    name,
    value,
    onChange,
    options,
    className,
    colors
}: RadioGroupProps<T>) {

    const styleVars = {
        "--rg-border": colors?.border ?? "#ccc",
        "--rg-foreground": colors?.foreground ?? "rgba(0,0,0,0.25)",
        "--rg-background": colors?.background ?? "#fff",
        "--rg-hover": colors?.hover ?? "#fff"
    } as React.CSSProperties;

    return (
        <div className={`radio-group row ${className ?? ""}`}
            style={styleVars}>
            {options.map((opt) => {
                const checked = opt.value === value;

                return (
                    <div className='radio-item-container' key={String(opt.value)}>
                        <label
                            className={`radio-item ${checked ? "checked" : ""}`}
                        >
                            <input
                                type="radio"
                                name={name}
                                value={String(opt.value)}
                                checked={checked}
                                onChange={() => onChange(opt.value)}
                                className="radio-input"
                            />
                        </label>

                        <span className="radio-label">{opt.label}</span>
                    </div>
                );
            })}
        </div>
    );
}
